import { atom } from "jotai";
import type { IAgendaQuery } from "lib/queries/__generated__/AgendaQuery.generated";

export const eventsCalendarAtom = atom<IAgendaQuery | null>(null);
